import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/core'
import styled from '@emotion/styled'
import posed from 'react-pose'
import SubtitleEffect from 'react-reveal/Fade'
import withReveal from 'react-reveal/withReveal'
import { MOBILE_MEDIA_QUERY } from 'typography-breakpoint-constants'

import { rhythm, scale } from '../utils/typography'
import { HeaderLogo, StickyLogo } from './logo'
import Navbar from './navbar'
import { mq } from '../utils/responsive'

const HeaderContainer = styled.header`
  .navbar {
    margin-left: ${rhythm(1)};
  }
`

const Brand = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  flex-direction: row;

  svg {
    margin-right: ${rhythm(0.8)};
  }

  ${mq.small(css`
    flex-direction: column;
    width: 100%;

    svg {
      margin-right: 0;
    }
  `)};
`

const BrandName = posed(styled.h1`
  ${scale(1.5)};
  margin-bottom: ${rhythm(0.5)};
  margin-top: 0;
  line-height: ${rhythm(0.9)};
  padding: 4px;
  display: inline-block;
`)({
  hoverable: true,
  init: {
    scale: 1,
    backgroundColor: 'rgba(255, 255, 255, 0)',
  },
  hover: {
    scale: 1.1,
    backgroundColor: 'rgba(45, 246, 213, 0.3)',
  },
})

const BrandHover = posed(Brand)({
  hoverable: true,
})

const Titles = styled.div`
  ${MOBILE_MEDIA_QUERY} {
    text-align: center;
  }
`

const Subtitle = withReveal(
  styled.h2`
    ${scale(0.8)};
    padding-left: 4px;
    font-weight: bold;
  `,
  <SubtitleEffect />
)

function Header({ subtitle, site, langKey, currentUrl }) {
  return (
    <HeaderContainer>
      <StickyLogo />
      <BrandHover>
        <HeaderLogo />
        <Titles>
          <BrandName>
            <Link
              style={{
                boxShadow: 'none',
                textDecoration: 'none',
                color: 'inherit',
              }}
              to={`/${langKey}`}
            >
              Karalabel
            </Link>
          </BrandName>
          {subtitle && (
            <Subtitle dangerouslySetInnerHTML={{ __html: subtitle }} />
          )}
        </Titles>
      </BrandHover>
      <Navbar site={site} langKey={langKey} currentUrl={currentUrl} />
    </HeaderContainer>
  )
}

export default Header
